import { Injectable, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

import { TemplateProps } from '../components/auth-template/auth-template.model';
import { ForgotPswProps } from '../forgot-password/forgot-password.model';
import { LoginProps } from '../login/login.model';
import { RegisterProps } from '../register/register.model';

export type UILoginService = {
  onLogin: (login: NgForm, resendEmail: TemplateRef<any>) => Promise<void>;
  resendEmailVerification: () => Promise<void>;
}

export interface UIForgotPasswordService {
  onSubmit: (forgotPassword: NgForm) => Promise<void>;
}

export interface UIRegisterService {
  onRegister: (register: NgForm) => Promise<void>;
}

export interface UIAuthServiceInit {
  forgotPassword: UIForgotPasswordService;
  login: UILoginService;
  register: UIRegisterService;
}

export interface UIAuthConfig {
  templateImgUrl?: string;
}

export type UIAuthTranslations = Partial<{
  authTemplate: TemplateProps;
  forgotPassword: ForgotPswProps;
  login: LoginProps;
  register: RegisterProps;
}>

@Injectable({
  providedIn: 'root'
})
export class AuthMethodsService {
  loginPageService?: UILoginService;
  forgotPageService?: UIForgotPasswordService;
  registerPageService?: UIRegisterService;
  config?: UIAuthConfig;
  translations = new BehaviorSubject<UIAuthTranslations>({});

  init(params: UIAuthServiceInit, config?: UIAuthConfig, translations?: UIAuthTranslations): void {
    this.config = config;
    this.forgotPageService = params.forgotPassword
    this.loginPageService = params.login
    this.registerPageService = params.register;
    this.translations.next(translations || {});
  }
}
